import * as ISEParserConstants from "./ISECalibrationConstants";
import {
  STATUS_FAILURE,
  STATUS_SUCCESS,
  STATUS_PENDING,
} from "Common/constants/commonConstants"; 
// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require("object.assign");

/**
 * initial state which is managed by ISECalibrationReducer
 */
const initialState = {
  isLoading: false,
  reports: [],
  error: null,
  isError:false
};

/**'
 * redux reducer method which takes the current state and the action as input parameters and returns with the new state
 */
export default function ISECalibrationReducer(state = initialState, action) {
  switch (action.type) {
    case ISEParserConstants.FETCH_ISE_CALIBRATION_INFO_REQUEST:
      return {
        ...state,
        isLoading: STATUS_PENDING,
        error: "",
        isError: false
      };
    case ISEParserConstants.FETCH_ISE_CALIBRATION_INFO_SUCCESS:
      return {
        ...state,
        isLoading: STATUS_SUCCESS,
        reports: action.payload?.result?.calibrationData,
        error: "",
        isError: false
      };
    case ISEParserConstants.FETCH_ISE_CALIBRATION_INFO_ERROR:
      return {
        ...state,
        reports: [],
        isLoading: STATUS_FAILURE,
        error: action.payload,
        isError: true
      };

    case ISEParserConstants.CLOSE_ERROR_MESSAGE_POPUP:
      return {
        ...state,
        isError: false,
        error: "",
      };

    default:
      return state;
  }
}
